import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { CoreValueDropdown } from '../../../../components/coreValueDropdown/CoreValueDropdown';
import DescriptionBox from '../../../../components/descriptionBox/DescriptionBox';
import Guidance from '../guidance/Guidance';
import {
    useGetCoachingCoachingStrengthQuery,
    usePostCoachingCreateCoachingStrengthMutation,
} from '../strengthSlice';
import '../strengths.scss';
import { SearchStrengthRequest } from '../types';
import { CoachingEntityTypes, CoachingTabs } from '../../../../utils/typeConstants';

export type StrengthProps = {
    OnViewState: (viewState: 'read' | 'edit' | 'new') => void;
    OnDisplayModal: (displayModal: boolean) => void;
    displayModal: boolean;
    authorId: string;
    authorName: string;
    recieverId: string;
    receiverName: string;
    parentStrengthViewState?: string;
    month?: number;
    year?: number;
    via?: number;
    coachingEntityId?: number;
    coachingEntityTypeId: number;
    strengthDesc?: string;
    strengthTitle?: string;
};

const NewStrength = ({
    displayModal,
    receiverName,
    parentStrengthViewState,
    authorName,
    recieverId,
    authorId,
    OnViewState,
    OnDisplayModal,
    month,
    year,
    via,
    coachingEntityId,
    coachingEntityTypeId,
    strengthDesc,
    strengthTitle,
}: StrengthProps) => {
    const [CreateStrength] = usePostCoachingCreateCoachingStrengthMutation();
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [coreValue, setCoreValue] = useState(0);
    const [date, setDate] = useState(new Date());
    const [inputMonth, setMonth] = useState(new Date().getMonth() + 1);
    const [inputYear, setYear] = useState(new Date().getFullYear());
    const [isGuidanceVisible, setIsGuidanceVisible] = useState<boolean>(false);
    const [previousMonthNumber, setPreviousMonthNumber] = useState(0);
    const [strneghtsList, setStrengthLIst] = useState<any>([]);
    const [cance, setCancel] = useState<boolean>(false);
    const [previousYear, setPreviousYear] = useState(0);

    useEffect(() => {
        // Function to get the current and previous month names
        const getMonthNames = () => {
            if (typeof month === 'number' && typeof year === 'number') {
                const date = new Date(year, month - 1, 1);
                date.setMonth(date.getMonth() - 1);
                setPreviousMonthNumber(date.getMonth() + 1); // Adding 1 because getMonth() returns zero-based index
                setPreviousYear(date.getFullYear());
            }
        };

        // Call the function when the component mounts
        getMonthNames();
    }, [month, year]);

    const setViewState = (viewState: 'read' | 'edit' | 'new') => {
        OnViewState(viewState);
    };

    const initParams = () => {
        // add keys only if value exists
        const params: SearchStrengthRequest = {
            employeeNumber: recieverId,
        };

        if (authorId) {
            params.authorEmployeeNumber = authorId;
        }

        if (month && year && (inputMonth === undefined || inputYear === undefined)) {
            setMonth(month);
            setYear(year);
        }

        params.month = previousMonthNumber;
        params.year = previousYear;

        return params;
    };

    const { data: strengths } = useGetCoachingCoachingStrengthQuery(initParams(), {
        skip: !previousMonthNumber || !previousYear,
    });

    useEffect(() => {
        setStrengthLIst(strengths?.data || []);
    }, [strengths]);

    const DateOnChange = (e: any) => {
        setMonth(e.value.getMonth() + 1);
        setYear(e.value.getFullYear());
    };

    useEffect(() => {
        if (year && month) {
            const date = new Date(year, month - 1);
            setDate(date);
            setMonth(month);
            setYear(year);
        }
    }, []);
    useEffect(() => {
        if (
            coachingEntityTypeId === CoachingEntityTypes.CoachingInsights ||
            coachingEntityTypeId === CoachingEntityTypes.Recordings
        ) {
            setDescription(strengthDesc || '');
            setTitle(strengthTitle || '');
        }
    }, [coachingEntityTypeId]);
    const validate = () => {
        const errors: string[] = [];
        if (title.trim().length === 0) {
            errors.push('Title is required \n');
        }

        if (!coreValue || coreValue === 0) {
            errors.push('TTEC value is required \n');
        }

        if (description.trim().length < 10) {
            errors.push('Description is required and must be at least 10 characters \n');
        }
        if (errors.length > 0) {
            errors.forEach((error) => toast.error(error));
            return false;
        }
        return true;
    };

    const handleCancel = () => {
        console.log('handleCancel', parentStrengthViewState);
        if (parentStrengthViewState === 'new') {
            OnDisplayModal(false);
        } else if (parentStrengthViewState === 'read') {
            setViewState('read');
        }
        setCancel(false);
        setTitle('');
        setCoreValue(0);
        setDescription('');
    };
    const handleGuidance = () => {
        setIsGuidanceVisible(!isGuidanceVisible);
    };

    const handleSave = () => {
        if (!validate()) return;
        const array = [];
        const request = {
            employeeNumber: recieverId,
            authorEmployeeNumber: authorId,
            strengthDescription: description,
            strengthTitle: title,
            coreValueId: coreValue,
            year: inputYear,
            month: inputMonth,
            coachingEntityId,
            coachingEntityTypeId,
        };
        array.push(request);

        CreateStrength({ createCoachingStrength: array })
            .unwrap()
            .then((res: any) => {
                if (res?.data) {
                    toast.success('Strength saved successfully');
                    setTitle('');
                    setCoreValue(0);
                    setDescription('');
                    if (via === CoachingTabs.CoachingInsights) OnDisplayModal(false);
                    else setViewState('read');
                } else toast.error('Something went wrong');
            })
            .catch((error: any) => {
                toast.error(error);
            });
    };

    const handleDescriptionChange = (value: string) => {
        setDescription(value);
    };
    const renderHeader = () => {
        return (
            <div>
                <h3>Strengths</h3>
            </div>
        );
    };

    const renderNewStrnegthDialog = () => {
        return (
            <Dialog
                header={renderHeader()}
                visible={displayModal}
                onHide={() => {
                    OnDisplayModal(false);
                    OnViewState('read');
                }}
                className="card shadow bg-body rounded mt-4 border-0 p-4 w-80"
                modal
                draggable={false}
                resizable={false}
                style={{
                    width: '73vw',
                    height: '90vh',
                }}
                position="top-right"
                footer={
                    <div className="row align-items-start">
                        <div className="col-2 p-2 text-center">
                            <Button
                                icon="pi pi-question-circle"
                                className="btn-primary"
                                label="Guidelines"
                                onClick={() => handleGuidance()}
                            />
                        </div>
                    </div>
                }
            >
                <div className="flexHeader mt-3">
                    <h5 className="mb-2">New Strength</h5>
                    <div>Assigned To: {receiverName}</div>
                </div>

                <div className="logConversation-coaching mt-4 mb-4">
                    <div className="flex-coaching mb-3">
                        <div className="col-4 me-2">
                            <h6>Title</h6>
                            <div>
                                <InputText
                                    data-testid="subject-input"
                                    placeholder="Title"
                                    className="w-100 borderRadius8"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="me-2">
                            <h6>Month</h6>
                            <div>
                                <Calendar
                                    id="selectmonth"
                                    value={date}
                                    onChange={DateOnChange}
                                    view="month"
                                    maxDate={new Date()}
                                    showIcon
                                    className="custom-calendar"
                                    dateFormat="MM, yy"
                                // style={{ width: '20rem' }}
                                />
                            </div>
                        </div>

                        <div className="col-4 me-2">
                            <CoreValueDropdown fullWidth coreValue={coreValue} setCoreValue={setCoreValue} />
                        </div>
                    </div>
                    <div>
                        <DescriptionBox
                            createdByLabel="Author"
                            createdByValue={authorName}
                            title={'Description'}
                            responseDescription={description}
                            value={description}
                            limit={4000}
                            onChange={handleDescriptionChange}
                        />
                    </div>
                    <div
                        style={{ display: 'flex', justifyContent: 'space-between' }}
                        className="flexButtons mt-3"
                    >
                        <div>&nbsp;</div>
                        <div>
                            <Button
                                label="Cancel"
                                onClick={handleCancel}
                                className="btn-secondary me-2"
                            />
                            <Button label="Save" onClick={handleSave} className="btn-primary me-2" />
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    };

    const handleCancelCarry = () => {
        OnDisplayModal(true);
        setCancel(true);
    };

    // const renderCarryForwrd = () => {
    //     return (
    //         <Dialog
    //             header={renderHeader()}
    //             visible={displayModal}
    //             onHide={() => {
    //                 OnDisplayModal(false);
    //                 // OnViewState('read');
    //             }}
    //             className="card shadow bg-body rounded mt-4 border-0 p-4 w-80"
    //             modal
    //             draggable={false}
    //             resizable={false}
    //         >
    //             <div className="m-top-10">
    //                 You have an entry for {previousMonthName}. Would you like to make that active for{' '}
    //                 {currentMonthName}
    //             </div>
    //             <div className="flexButtons m-top-10">
    //                 <Button
    //                     className="p-button-outlined borderRadius10 m-right-20"
    //                     onClick={handleCancelCarry}
    //                     label={'Cancel'}
    //                 />
    //                 <Button className="borderRadius10" onClick={handleClickYes} label={'Carry Forward'} />
    //             </div>
    //         </Dialog>
    //     );
    // }; //Eliminate the "Carry Forward" Strength button from the Strengths UI (JIRA : E20-4209)
    //This feature will be turned off for now, so we’re not fixing the bug.
    // We will note in the code that if its turned on again, theres an existing bug(JIRA : E20-4576).

    return (
        <>
            {parentStrengthViewState === 'new' &&
                !cance &&
                strneghtsList.length >= 0 &&
                renderNewStrnegthDialog()}
            {parentStrengthViewState === 'new' && !cance && strneghtsList.length > 0 && handleCancelCarry()}
            {/* {parentStrengthViewState === 'new' && !cance && strneghtsList.length > 0 && renderCarryForwrd()} Eliminate the "Carry Forward" Strength button from the Strengths UI (JIRA : E20-4209)
            //This feature will be turned off for now, so we’re not fixing the bug.
    // We will note in the code that if its turned on again, theres an existing bug(JIRA : E20-4576). */}
            {/* {parentStrengthViewState === 'new' && !cance && strneghtsList.length > 0 && renderCarryForwrd()} Eliminate the "Carry Forward" Strength button from the Strengths UI (JIRA : E20-4209) */}
            {parentStrengthViewState === 'read' && !cance && renderNewStrnegthDialog()}
            {cance && renderNewStrnegthDialog()}
            {isGuidanceVisible && (
                <Guidance from={'New'} isGuidanceVisible={isGuidanceVisible} onHide={handleGuidance} />
            )}
        </>
    );
};
export default NewStrength;
